import React, { Component } from "react";
import WaveSurfer from "wavesurfer.js";
import Utils from "@/utils";
import moment from "moment";
import sentGAEvent from "@/ga";
import AudioJoinerWorkListItemRender from "./children/AudioJoinerWorkListItemRender";

import "@/assets/audioJoiner.less";

class AudioJoinerWorkListItemFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioAccept: ".wav,.mp3,.m4a,.aac,.ogg",
      workPlaceVisible: true,
      duration: "00:00.00",
      currentTime: "00:00.00",
      currentTimePercent: 0,
      playing: false,
      start: "00:00.00",
      end: "00:00.00",
    };
    this.wavesurferRef = React.createRef();
    this.wavesurfer = null;
  }

  componentDidMount() {
    this.wavesurfer = WaveSurfer.create({
      barHeight: 0.8,
      backend: "MediaElement",
      container: this.wavesurferRef.current,
      waveColor: "#8372FF",
      progressColor: "#8372FF",
      backgroundColor: "#261F3F",
      height: this.props.active ? 160 : 80,
      cursorWidth: 0,
      hideScrollbar: true,
    });
    this.wavesurfer.on("audioprocess", () => {
      let currentTimeNumber = this.wavesurfer.getCurrentTime();
      let currentVolume = this.wavesurfer.getVolume();
      if (this.wavesurfer.isPlaying()) {
        if (!this.props.audioJoinerItem.fadeIn && !this.props.audioJoinerItem.fadeOut) {
          if (currentVolume !== 1) {
            this.wavesurfer.setVolume(1);
          }
        } else {
          //淡入
          if (this.props.audioJoinerItem.fadeIn) {
            if (currentTimeNumber <= Utils.getSeconds(this.props.audioJoinerItem.start) + 3) {
              let newVolume = parseFloat(
                ((1 / 3) * (this.wavesurfer.getCurrentTime() - Utils.getSeconds(this.props.audioJoinerItem.start))).toFixed(2)
              );
              console.log("淡入", newVolume);
              if (newVolume >= 0 && newVolume <= 1) {
                this.wavesurfer.setVolume(newVolume);
              }
            } else if (currentTimeNumber >= Utils.getSeconds(this.props.audioJoinerItem.start) + 3 && currentVolume !== 1) {
              if (this.props.audioJoinerItem.fadeOut) {
                if (currentTimeNumber <= Utils.getSeconds(this.props.audioJoinerItem.end) - 3) {
                  this.wavesurfer.setVolume(1);
                }
              } else {
                this.wavesurfer.setVolume(1);
              }
            }
          }
          //淡出
          if (this.props.audioJoinerItem.fadeOut) {
            if (currentTimeNumber >= Utils.getSeconds(this.props.audioJoinerItem.end) - 3) {
              let newVolume = parseFloat(
                ((1 / 3) * (Utils.getSeconds(this.props.audioJoinerItem.end) - this.wavesurfer.getCurrentTime())).toFixed(2)
              );
              console.log("淡出", newVolume);
              if (newVolume >= 0 && newVolume <= 1) {
                this.wavesurfer.setVolume(newVolume);
              }
              //跟下一条叠着播放
              if (this.props.index < this.props.audioJoinerList.length - 1 && this.props.audioJoinerList.length > 1) {
                if (this.props.handlePlayFinishCallBack) {
                  this.props.handlePlayFinishCallBack(this.props.index);
                }
              }
            } else if (currentTimeNumber <= Utils.getSeconds(this.props.audioJoinerItem.end) - 3 && currentVolume !== 1) {
              if (this.props.audioJoinerItem.fadeIn) {
                if (currentTimeNumber >= Utils.getSeconds(this.props.audioJoinerItem.start) + 3) {
                  this.wavesurfer.setVolume(1);
                }
              } else {
                this.wavesurfer.setVolume(1);
              }
            }
          }
        }

        if (currentTimeNumber >= Utils.getSeconds(this.props.audioJoinerItem.end)) {
          this.wavesurfer.pause();
        }
        this.setState({
          currentTime: moment("00:00:00", "mm:ss:SS")
            .add(currentTimeNumber, "seconds")
            .format("mm:ss:SS")
            .replace(/:([^:]*)$/, ".$1"),
          currentTimePercent: (currentTimeNumber / this.wavesurfer.getDuration()) * 100,
        });
        this.props.handleCurrentTimeFormItem(
          this.props.index,
          ((currentTimeNumber - Utils.getSeconds(this.props.audioJoinerItem.start)) / this.props.mergeDuration) * 100
        );
      }
    });
    this.wavesurfer.on("finish", () => {
      console.log("播放完毕");
      if (this.props.handlePlayFinishCallBack) {
        this.props.handlePlayFinishCallBack(this.props.index);
      }
    });
    this.wavesurfer.on("interaction", () => {
      if (!this.wavesurfer.isPlaying()) {
        this.setState({
          currentTime: moment("00:00:00", "mm:ss:SS")
            .add(this.wavesurfer.getCurrentTime(), "seconds")
            .format("mm:ss:SS")
            .replace(/:([^:]*)$/, ".$1"),
          currentTimePercent: (this.wavesurfer.getCurrentTime() / this.wavesurfer.getDuration()) * 100,
        });
      }
    });
    this.wavesurfer.on("pause", () => {
      console.log("播放暂停");
      if (this.wavesurfer.getCurrentTime() >= Utils.getSeconds(this.props.audioJoinerItem.end)) {
        if (this.props.handlePlayFinishCallBack) {
          this.props.handlePlayFinishCallBack(this.props.index);
        }
      }
    });
    this.wavesurfer.on("play", () => {
      console.log("播放播放");
    });
    this.wavesurfer.on("ready", () => {
      console.log("加载完毕");
      const audioJoinerItem = { ...this.props.audioJoinerItem };
      audioJoinerItem.wavesurfer = this.wavesurfer;
      this.props.handleAudioJoinerItemChange(audioJoinerItem);
    });
    this.wavesurfer.load(this.props.audioJoinerItem.videofileurl);
  }

  getCutPercent = value => {
    const d = Utils.getSeconds(this.props.audioJoinerItem.duration);
    const t = Utils.getSeconds(value);
    return (t / d) * 100;
  };

  handleCurrentTimeChange = value => {
    if (
      this.wavesurfer.getDuration() * (value / 100) < Utils.getSeconds(this.props.audioJoinerItem.start) ||
      this.wavesurfer.getDuration() * (value / 100) > Utils.getSeconds(this.props.audioJoinerItem.end)
    ) {
      return false;
    }
    this.wavesurfer.setCurrentTime(this.wavesurfer.getDuration() * (value / 100));
    this.setState({
      currentTime: moment("00:00:00", "mm:ss:SS")
        .add(this.wavesurfer.getCurrentTime(), "seconds")
        .format("mm:ss:SS")
        .replace(/:([^:]*)$/, ".$1"),
      currentTimePercent: value,
    });
    this.props.handleCurrentTimeFormItem(
      this.props.index,
      ((this.wavesurfer.getCurrentTime() - Utils.getSeconds(this.props.audioJoinerItem.start)) / this.props.mergeDuration) * 100
    );
  };

  handleRangeChange = value => {
    this.props.handleTimeChangeType("track");
    this.props.handlePauseAllAudio();
    if (!this.props.active) {
      return false;
    }
    const d = Utils.getSeconds(this.props.audioJoinerItem.duration);
    this.setState({ miniLengthLimit: false });
    this.setState({ maxLengthLimit: false });
    const audioJoinerItem = { ...this.props.audioJoinerItem };
    audioJoinerItem.start = moment("00:00:00", "mm:ss:SS")
      .add((d * value[0]) / 100, "seconds")
      .format("mm:ss:SS")
      .replace(/:([^:]*)$/, ".$1");
    audioJoinerItem.end = moment("00:00:00", "mm:ss:SS")
      .add((d * value[1]) / 100, "seconds")
      .format("mm:ss:SS")
      .replace(/:([^:]*)$/, ".$1");
    if (value[0] >= this.state.currentTimePercent) {
      this.wavesurfer.setCurrentTime(this.wavesurfer.getDuration() * (value[0] / 100));
      this.setState({
        currentTime: moment("00:00:00", "mm:ss:SS")
          .add((this.wavesurfer.getDuration() * value[0]) / 100, "seconds")
          .format("mm:ss:SS")
          .replace(/:([^:]*)$/, ".$1"),
        currentTimePercent: value[0],
      });
    } else if (value[1] <= this.state.currentTimePercent) {
      this.wavesurfer.setCurrentTime(this.wavesurfer.getDuration() * (value[1] / 100));
      this.setState({
        currentTime: moment("00:00:00", "mm:ss:SS")
          .add((this.wavesurfer.getDuration() * value[1]) / 100, "seconds")
          .format("mm:ss:SS")
          .replace(/:([^:]*)$/, ".$1"),
        currentTimePercent: value[1],
      });
    }
    // this.wavesurfer.setCurrentTime(this.wavesurfer.getDuration() * (value[0] / 100));
    // this.setState({
    //   currentTime: moment("00:00:00", "mm:ss:SS")
    //     .add((d * value[0]) / 100, "seconds")
    //     .format("mm:ss:SS")
    //     .replace(/:([^:]*)$/, ".$1"),
    //   currentTimePercent: (this.wavesurfer.getCurrentTime() / this.wavesurfer.getDuration()) * 100,
    // });
    this.props.handleCurrentTimeFormItem(
      this.props.index,
      ((this.wavesurfer.getCurrentTime() - (d * value[0]) / 100) / this.props.mergeDuration) * 100
    );
    this.props.handleAudioJoinerItemChange(audioJoinerItem);
  };

  handleSliderTips = value => {
    const d = Utils.getSeconds(this.props.audioJoinerItem.duration);
    let differenceSecond = (d * value) / 100 - Utils.getSeconds(this.props.audioJoinerItem.start);
    if (differenceSecond >= -1 && differenceSecond <= 1) {
      return this.props.audioJoinerItem.start;
    } else {
      return this.props.audioJoinerItem.end;
    }
  };

  handleSliderCurrentTimeTips = () => {
    return moment("00:00:00", "mm:ss:SS")
      .add(this.wavesurfer.getCurrentTime(), "seconds")
      .format("mm:ss:SS")
      .replace(/:([^:]*)$/, ".$1");
  };

  handleTimeChange = (value, key) => {
    this.props.handleTimeChangeType("ambos");
    if (key === "end" && value > 0) {
      if (Utils.getSeconds(this.props.audioJoinerItem.end) >= this.wavesurfer.getDuration()) {
        return false;
      }
    } else if (key === "start" && value < 0) {
      if (Utils.getSeconds(this.props.audioJoinerItem.start) <= 0) {
        return false;
      }
    }
    const audioJoinerItem = { ...this.props.audioJoinerItem };
    audioJoinerItem[key] = moment("00:00:00", "mm:ss:SS")
      .add(Utils.getSeconds(audioJoinerItem[key]) + value, "seconds")
      .format("mm:ss:SS")
      .replace(/:([^:]*)$/, ".$1");
    this.props.handleAudioJoinerItemChange(audioJoinerItem);
  };

  handleFade = type => {
    const audioJoinerItem = { ...this.props.audioJoinerItem };
    if (type === "in") {
      sentGAEvent({
        category: "audio_merge_action",
        action: "audio_merge_fade_click",
        label: "fade_in_click",
      });
      audioJoinerItem.fadeIn = audioJoinerItem.fadeIn ? false : true;
      this.props.handleAudioJoinerItemChange(audioJoinerItem);
    } else {
      sentGAEvent({
        category: "audio_merge_action",
        action: "audio_merge_fade_click",
        label: "fade_out_click",
      });
      audioJoinerItem.fadeOut = audioJoinerItem.fadeOut ? false : true;
      if (this.props.index < this.props.audioJoinerList.length - 1) {
        let nextAudioJoinerItem = { ...this.props.audioJoinerList[this.props.index + 1] };
        nextAudioJoinerItem.fadeIn = true;
        this.props.handleAudioJoinerItemChange(audioJoinerItem, { index: this.props.index + 1, audioJoinerItem: nextAudioJoinerItem });
      } else {
        this.props.handleAudioJoinerItemChange(audioJoinerItem);
      }
    }
  };

  componentWillUnmount() {
    if (this.wavesurfer) {
      if (this.wavesurfer.isPlaying()) {
        this.wavesurfer.pause();
      }
      this.wavesurfer.destroy();
      this.wavesurfer = null;
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.active !== this.props.active) {
      if (this.props.active) {
        this.wavesurfer.setHeight(160);
      } else {
        this.wavesurfer.setHeight(80);
      }
    }
  }

  render() {
    return (
      <AudioJoinerWorkListItemRender
        active={this.props.active}
        index={this.props.index}
        audioJoinerItem={this.props.audioJoinerItem}
        audioJoinerList={this.props.audioJoinerList}
        wavesurferRef={this.wavesurferRef}
        currentTime={this.state.currentTime}
        currentTimePercent={this.state.currentTimePercent}
        getCutPercent={this.getCutPercent}
        handleChangeSort={this.props.handleChangeSort}
        handleFade={this.handleFade}
        handleSelected={this.props.handleSelected}
        handleSliderTips={this.handleSliderTips}
        handleDeleteAudioJoinerItem={this.props.handleDeleteAudioJoinerItem}
        handleCurrentTimeChange={this.handleCurrentTimeChange}
        handleRangeChange={this.handleRangeChange}
        handleTimeChange={this.handleTimeChange}
      />
    );
  }
}

export default AudioJoinerWorkListItemFunction;
